import React, { Suspense } from "react";

import { Loader } from "@components/common";
import {
  MFAFormLoader,
  passwordRecoveryAction,
  registerAction,
  registerMFAAction,
} from "@components/form";
import { GuestLayout } from "@layouts";
import {
  ConfirmEmailPage,
  LoginPage,
  MfaPage,
  PasswordRecoveryPage,
  RegisterPage,
  RegisterSupplierPage,
  ResetPasswordPage,
} from "@pages";

export const guestRoutes = [
  {
    element: (
      <Suspense fallback={<Loader />}>
        <GuestLayout />
      </Suspense>
    ),
    children: [
      {
        element: <RegisterPage />,
        path: "register",
        action: registerAction,
      },
      {
        element: <RegisterSupplierPage />,
        path: "register-supplier/:companyId",
      },
      {
        element: <LoginPage />,
        path: "login",
      },
      {
        element: <PasswordRecoveryPage />,
        path: "password-recovery",
        action: passwordRecoveryAction,
      },
      {
        element: <ResetPasswordPage />,
        path: "reset-password",
      },
      {
        element: <MfaPage />,
        path: "mfa",
        action: registerMFAAction,
        loader: MFAFormLoader,
      },
      {
        element: <ConfirmEmailPage />,
        path: "confirm-email",
      },
    ],
  },
];
